import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
    detailed: {
        data: [],
        pagination: { page_number: 1, page_size: 25, total_records: 0, total_pages: 0 },
        grand_total: 0,
        isLoading: false
    },
    uninvoiced: {
        data: [],
        pagination: { page_number: 1, page_size: 25, total_records: 0, total_pages: 0 },
        grand_total: '0',
        isLoading: false
    }
};

const slice = createSlice({
    name: 'invoiceReports',
    initialState,
    reducers: {
        startDetailedReport(state, action) {
            state.detailed.isLoading = true;
        },
        setDetailedReport(state, action) {
            const payload = action.payload || {};
            state.detailed.data = payload.data || [];
            state.detailed.pagination = payload.pagination || state.detailed.pagination;
            state.detailed.grand_total = payload.grand_total || 0;
            state.detailed.isLoading = false;
        },
        startUninvoicedReport(state, action) {
            state.uninvoiced.isLoading = true;
        },
        setUninvoicedReport(state, action) {
            const payload = action.payload || {};
            state.uninvoiced.data = payload.data || [];
            state.uninvoiced.pagination = payload.pagination || state.uninvoiced.pagination;
            state.uninvoiced.grand_total = payload.grand_total || state.uninvoiced.grand_total;
            state.uninvoiced.isLoading = false;
        },
        completedAction(state) {
            state.detailed.isLoading = false;
            state.uninvoiced.isLoading = false;
        }
    }
});

export const { startDetailedReport, setDetailedReport, startUninvoicedReport, setUninvoicedReport, completedAction } = slice.actions;

export default slice.reducer;

const invoiceReportsState = (state) => state.invoiceReports;

export const detailedReportSelector = createSelector([invoiceReportsState], (s) => s.detailed);
export const uninvoicedReportSelector = createSelector([invoiceReportsState], (s) => s.uninvoiced);
